import { useEffect, useRef, useState } from "react";

export default function useHorizontalScroll() {
  const scrollRef = useRef(null);
  const [isGrabbing, setIsGrabbing] = useState(false);
  const position = useRef({ startX: 0, scrollLeft: 0, velocity: 0 });
  const momentumRef = useRef(null);

  // ✅ Wheel Scroll: lebih halus dan smooth
  const onWheel = (e) => {
    if (!scrollRef.current) return;
    if (e.deltaY === 0) return;

    e.preventDefault();

    const scrollAmount = e.deltaY * 0.7; // dikurangi agar lebih smooth
    scrollRef.current.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    });
  };

  // ✅ Mouse Drag Start
  const onMouseDown = (e) => {
    if (!scrollRef.current) return;
    cancelMomentumScroll(); // hentikan momentum sebelumnya

    setIsGrabbing(true);
    scrollRef.current.style.cursor = "grabbing";
    scrollRef.current.style.userSelect = "none";

    position.current = {
      startX: e.pageX,
      scrollLeft: scrollRef.current.scrollLeft,
      velocity: 0,
    };
  };

  // ✅ Mouse Drag Move
  const onMouseMove = (e) => {
    if (!scrollRef.current || !isGrabbing) return;

    const dx = e.pageX - position.current.startX;
    const newScrollLeft = position.current.scrollLeft - dx;

    // Hitung kecepatan gerakan (untuk efek momentum)
    position.current.velocity = newScrollLeft - scrollRef.current.scrollLeft;

    scrollRef.current.scrollLeft = newScrollLeft;
  };

  // ✅ Mouse Up: tambahkan efek momentum lembut
  const onMouseUp = () => {
    if (!scrollRef.current) return;

    setIsGrabbing(false);
    scrollRef.current.style.cursor = "grab";
    scrollRef.current.style.userSelect = "";

    beginMomentumScroll();
  };

  // ---- Momentum Scroll ----
  const beginMomentumScroll = () => {
    cancelMomentumScroll();

    const step = () => {
      if (!scrollRef.current) return;
      scrollRef.current.scrollLeft += position.current.velocity;
      position.current.velocity *= 0.95; // kurangi kecepatan bertahap (gesekan)

      if (Math.abs(position.current.velocity) > 0.5) {
        momentumRef.current = requestAnimationFrame(step);
      } else {
        cancelMomentumScroll();
      }
    };

    momentumRef.current = requestAnimationFrame(step);
  };

  const cancelMomentumScroll = () => {
    if (momentumRef.current) cancelAnimationFrame(momentumRef.current);
  };

  // ✅ Event Binding
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    el.style.cursor = "grab";
    el.addEventListener("wheel", onWheel, { passive: false });
    el.addEventListener("mousedown", onMouseDown);
    el.addEventListener("mousemove", onMouseMove);
    el.addEventListener("mouseup", onMouseUp);
    el.addEventListener("mouseleave", onMouseUp);

    return () => {
      el.removeEventListener("wheel", onWheel);
      el.removeEventListener("mousedown", onMouseDown);
      el.removeEventListener("mousemove", onMouseMove);
      el.removeEventListener("mouseup", onMouseUp);
      el.removeEventListener("mouseleave", onMouseUp);
      cancelMomentumScroll();
    };
  }, [isGrabbing]);

  return scrollRef;
}
